import React from "react"
import Cookies from "universal-cookie"

export function SearchBar(props) {
    const cookies = new Cookies()
    let vdm = "dark-mode"

    function handleChangeDarkmode(e) {
        props.setLightMode(!e.target.checked)
        if (document.body.classList.contains(vdm)) {
            document.body.classList.remove(vdm)
            cookies.remove("ppfrontend2_darkmode", { path: "/" })
        } else {
            document.body.classList.add(vdm)
            let expires = new Date()
            expires.setTime(expires.getTime() + 60 * 60 * 24 * 365 * 10 * 1000)
            cookies.set("ppfrontend2_darkmode", true, { path: "/", expires: expires })
        }
    }

    return (
        <form className="d-flex align-items-center ms-3" onSubmit={props.onSubmit}>
            <div className="input-group input-group-sm">
                <input
                    id="inputSearch"
                    name="searchinput"
                    className="form-control form-control-navbar"
                    type="search"
                    placeholder="EAN, Name, .."
                    aria-label="Search"
                    defaultValue={props.searchword}
                    key={props.searchword}
                />
                <button id="inputSearchButton" type="submit" className="btn btn-primary btn-flat">
                    <i className="fas fa-search" />
                </button>
            </div>
            <div className="mx-3 form-check form-switch">
                <input
                    type="checkbox"
                    className="form-check-input"
                    id="customSwitch3"
                    onChange={handleChangeDarkmode}
                    defaultChecked={!props.lightMode}
                />
                <label className="form-check-label fw-normal" htmlFor="customSwitch3">
                    Darkmode
                </label>
            </div>
        </form>
    )
}
